/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState } from 'react';

import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';

import { Input } from 'src/components/Input';
import { studentTrueUpInputValidationRules } from 'src/components/RateCardDetail/ContractTerms/contractTermValidation';
import { Toggle } from 'src/components/Toggle';
import { InputValidationRuleType } from 'src/constants';
import { IContractTermsComponentProps } from 'src/types/IRateCard';
import { hasErrorMessage } from 'src/util/validationsUtil';

export const AdditionalSettings = ({
    contractTerms,
    handleContractTermValueChange,
    setIsContractTermInputValid,
    isEditMode,
    handleContractTermErrorMessageChange,
    contractTermErrorMessages,
    optionalSection,
    setOptionalSection
}: IContractTermsComponentProps) => {
    const [hasStudentTrueUpThreshold, setHasStudentTrueUpThreshold] = useState<boolean>(
        !!contractTerms.additionalSettings!.studentTrueUpThresholdValue!
    );

    const handleSetStudentTrueUpThresholdChange = (value: boolean) => {
        if (!handleContractTermErrorMessageChange) return;
        handleContractTermErrorMessageChange('additionalSettings', 'studentTrueUpThresholdValue', '');
        handleContractTermValueChange('additionalSettings', 'studentTrueUpThresholdValue', undefined);
        setHasStudentTrueUpThreshold(value);
        if (!setIsContractTermInputValid) return;
        setIsContractTermInputValid((prevState) => ({
            ...prevState,
            additionalSettings: hasStudentTrueUpThreshold
        }));
        const clonedOptionalSection = optionalSection!.map((x) => x);
        if (value) {
            if (setOptionalSection) {
                setOptionalSection(clonedOptionalSection.filter((e) => e !== 'additionalSettings'));
            }
        } else {
            if (setOptionalSection) {
                clonedOptionalSection.push('additionalSettings');
                setOptionalSection(clonedOptionalSection);
            }
        }
    };

    const handleStudentTrueUpThresholdInputChange = (newVal: string) => {
        handleContractTermValueChange('additionalSettings', 'studentTrueUpThresholdValue', newVal);
        if (!setIsContractTermInputValid) return;
        setIsContractTermInputValid((prevState) => ({
            ...prevState,
            additionalSettings: contractTerms.additionalSettings!.studentTrueUpThresholdValue != null
        }));
    };

    const handleStudentTrueUpErrorMessageChange = (newVal: string) => {
        if (!handleContractTermErrorMessageChange) return;
        handleContractTermErrorMessageChange('additionalSettings', 'studentTrueUpThresholdValue', newVal);
    };

    React.useEffect(() => {
        if (!setIsContractTermInputValid) return;
        setIsContractTermInputValid((prevState) => ({
            ...prevState,
            additionalSettings:
                !hasErrorMessage(contractTermErrorMessages!.additionalSettings) &&
                (!hasStudentTrueUpThreshold || contractTerms.additionalSettings!.studentTrueUpThresholdValue != null)
        }));
    }, [contractTermErrorMessages!.additionalSettings]);

    return (
        <Box className="box-border-light-gray" type="outline" spacingInset="400">
            <Column>
                <Heading level={3}>Additional settings</Heading>
                <Row alignmentVertical="top" widths="80%">
                    <Column>
                        <Row>
                            <Toggle
                                label={isEditMode ? '' : 'Student true up threshold'}
                                value={hasStudentTrueUpThreshold}
                                text={contractTerms.additionalSettings!.studentTrueUpThresholdValue!}
                                isEditMode={isEditMode}
                                onChange={handleSetStudentTrueUpThresholdChange}
                            />
                            {isEditMode && (
                                <Input
                                    label="Student true-up threshold"
                                    value={contractTerms.additionalSettings!.studentTrueUpThresholdValue ?? ''}
                                    onChange={handleStudentTrueUpThresholdInputChange}
                                    isRequired={true}
                                    isEditMode={isEditMode}
                                    validationRules={studentTrueUpInputValidationRules}
                                    errorMessage={
                                        contractTermErrorMessages!.additionalSettings.studentTrueUpThresholdValue
                                    }
                                    handleErrMsgChange={handleStudentTrueUpErrorMessageChange}
                                    disabled={!hasStudentTrueUpThreshold}
                                    type="number"
                                />
                            )}
                        </Row>
                    </Column>
                </Row>
            </Column>
        </Box>
    );
};
